var _g, _circle, _circle2, _circle3, _g2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _circle4, _rect49, _rect50, _path, _path2, _path3, _circle5, _path4, _path5, _path6, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFaviconNoel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 452,
    height: 475,
    viewBox: "0 0 452 475",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_608_684)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M294.006 37.0589C291.558 36.6023 289.294 36.2512 286.975 35.8695C286.025 35.672 285.129 35.4031 284.176 35.2253C185.871 16.889 108.656 49.0967 100.555 92.5276C92.4542 135.959 155.87 143.535 221.017 155.687C264.683 163.832 296.2 169.71 319.145 173.115L319.321 174.023L350.799 332.482L370.46 336.149C370.46 336.149 379.434 306.746 393.126 269.169C413.958 212.02 436.872 63.7071 294.006 37.0589Z",
    fill: "#DD2E44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.462 383.467C373.178 387.518 394.067 373.197 398.118 351.48C402.169 329.763 387.847 308.875 366.131 304.824C344.414 300.773 323.525 315.094 319.474 336.811C315.424 358.528 329.745 379.417 351.462 383.467Z",
    fill: "#F1F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.477 171.527C358.452 182.38 348.001 189.545 337.148 187.521L91.387 141.68C80.5342 139.656 73.3691 129.204 75.3934 118.352L77.227 108.521C79.2514 97.6684 89.7024 90.5033 100.555 92.5276L346.316 138.368C357.169 140.393 364.334 150.844 362.31 161.697L360.477 171.527Z",
    fill: "#F1F2F2"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 295,
    r: 180,
    fill: "#4E4B4D"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 295,
    r: 164,
    fill: "#262A31"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 289,
    r: 96,
    fill: "#393A3F"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_608_684)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.775 331.055C159.307 331.075 159.004 331.301 159.004 331.783V353.294C159.004 353.669 159.261 354.008 159.657 354.008H196.412C196.742 354.008 197.006 353.977 197.161 353.521C197.161 353.521 200.886 341.341 200.951 341.121C201.089 340.661 200.999 340.427 200.624 340.177C188.653 332.162 170.748 331 162.627 331C161.461 331 160.498 331.024 159.778 331.054",
    fill: "#716E6F"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 177,
    y: 131,
    width: 5,
    height: 44,
    fill: "#E2D752"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 152.718,
    width: 5,
    height: 44,
    transform: "rotate(-32.9276 95 152.718)",
    fill: "#E2D752"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 284,
    y: 358.307,
    width: 5,
    height: 44,
    transform: "rotate(-59.472 284 358.307)",
    fill: "#E2D752"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 213.257,
    width: 5,
    height: 44,
    transform: "rotate(-58.3662 38 213.257)",
    fill: "#E2D752"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 237,
    y: 400.652,
    width: 5,
    height: 44,
    transform: "rotate(-32.0287 237 400.652)",
    fill: "#E2D752"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 116.671,
    y: 397,
    width: 5,
    height: 44,
    transform: "rotate(29.5072 116.671 397)",
    fill: "#E2D752"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 72.4199,
    y: 353,
    width: 5,
    height: 44,
    transform: "rotate(58.261 72.4199 353)",
    fill: "#E2D752"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 259.956,
    y: 150,
    width: 5,
    height: 44,
    transform: "rotate(31.4487 259.956 150)",
    fill: "#E2D752"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 319.445,
    y: 209,
    width: 5,
    height: 44,
    transform: "rotate(58.3241 319.445 209)",
    fill: "#E2D752"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 329.485,
    y: 232,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(70.4633 329.485 232)",
    fill: "#E2D752"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 337.259,
    y: 252,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(77.1294 337.259 252)",
    fill: "#E2D752"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 339.767,
    y: 273,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(84.9766 339.767 273)",
    fill: "#E2D752"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 339.939,
    y: 314.16,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(95.1942 339.939 314.16)",
    fill: "#E2D752"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 336.705,
    y: 335.42,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(106.088 336.705 335.42)",
    fill: "#E2D752"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 329.498,
    y: 355.977,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(114.719 329.498 355.977)",
    fill: "#E2D752"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 308.655,
    y: 392.191,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(129.548 308.655 392.191)",
    fill: "#E2D752"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 294.973,
    y: 408.184,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(136.076 294.973 408.184)",
    fill: "#E2D752"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 278.945,
    y: 422.046,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(142.97 278.945 422.046)",
    fill: "#E2D752"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 242.42,
    y: 443.634,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(161.562 242.42 443.634)",
    fill: "#E2D752"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 221.883,
    y: 451.171,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(169.362 221.883 451.171)",
    fill: "#E2D752"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 201.1,
    y: 454.832,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(177.292 201.1 454.832)",
    fill: "#E2D752"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 159.198,
    y: 454.927,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(-173.582 159.198 454.927)",
    fill: "#E2D752"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 137.876,
    y: 451.272,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(-161.7 137.876 451.272)",
    fill: "#E2D752"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 118.022,
    y: 444.032,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(-157.457 118.022 444.032)",
    fill: "#E2D752"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 82.5938,
    y: 422.416,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(-143.783 82.5938 422.416)",
    fill: "#E2D752"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 64.2957,
    y: 409.139,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(-130.984 64.2957 409.139)",
    fill: "#E2D752"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 50.7571,
    y: 393.578,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(-127.263 50.7571 393.578)",
    fill: "#E2D752"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 30.8096,
    y: 356.579,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(-114.19 30.8096 356.579)",
    fill: "#E2D752"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 23.5127,
    y: 337.099,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(-105.04 23.5127 337.099)",
    fill: "#E2D752"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 19.1714,
    y: 315.038,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(-94.9782 19.1714 315.038)",
    fill: "#E2D752"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 273.974,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(-88.1172 19 273.974)",
    fill: "#E2D752"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 251.876,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(-71.7103 23 251.876)",
    fill: "#E2D752"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 231.792,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(-65.0906 30 231.792)",
    fill: "#E2D752"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 196.479,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(-48.4517 52 196.479)",
    fill: "#E2D752"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 65.2881,
    y: 180.109,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(-46.2095 65.2881 180.109)",
    fill: "#E2D752"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 166.21,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(-37.772 81 166.21)",
    fill: "#E2D752"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 145.739,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(-21.9721 118 145.739)",
    fill: "#E2D752"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 138,
    y: 138.361,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(-10.5388 138 138.361)",
    fill: "#E2D752"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 159,
    y: 133.171,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(-4.9619 159 133.171)",
    fill: "#E2D752"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 200.986,
    y: 133,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(9.61784 200.986 133)",
    fill: "#E2D752"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 222.628,
    y: 137,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(18.6463 222.628 137)",
    fill: "#E2D752"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 241.661,
    y: 144.306,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(23.8044 241.661 144.306)",
    fill: "#E2D752"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 277.701,
    y: 165,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(38.0372 277.701 165)",
    fill: "#E2D752"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 294.43,
    y: 179,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(46.9326 294.43 179)",
    fill: "#E2D752"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 307.792,
    y: 196,
    width: 1.97554,
    height: 23.8583,
    transform: "rotate(56.0556 307.792 196)",
    fill: "#E2D752"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 177,
    y: 415,
    width: 5,
    height: 44,
    fill: "#E2D752"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 297,
    width: 5,
    height: 44,
    transform: "rotate(-90 300 297)",
    fill: "#E2D752"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 297,
    width: 5,
    height: 44,
    transform: "rotate(-90 16 297)",
    fill: "#E2D752"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 179.5,
    cy: 294.5,
    r: 165.5,
    stroke: "#4E4B4D",
    strokeWidth: 10
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 203.008,
    y: 319.417,
    width: 119.76,
    height: 20.4465,
    transform: "rotate(-147.247 203.008 319.417)",
    fill: "#B0A83E"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 147.855,
    y: 308.73,
    width: 155.882,
    height: 15.158,
    transform: "rotate(-37.5671 147.855 308.73)",
    fill: "#E2D752"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M282.224 214.848L280.647 225.696L271.32 213.725L282.224 214.848Z",
    fill: "#E2D752"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M101.96 242.207L113.393 237.425L102.305 254.594L101.96 242.207Z",
    fill: "#B0A83E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M360.477 171.527C358.452 182.38 348.001 189.545 337.149 187.521L91.3873 141.68C80.5345 139.656 73.3693 129.205 75.3936 118.352L77.2273 108.521C79.2516 97.6684 89.7026 90.5033 100.555 92.5276L346.317 138.368C357.17 140.393 364.335 150.844 362.31 161.697L360.477 171.527Z",
    fill: "#F1F2F2"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 292.5,
    cy: 407.5,
    r: 67.5,
    fill: "#01518B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M295.778 434.628V381.375L309.189 367.961C309.189 367.961 311.153 365.997 309.189 364.031C307.225 362.067 305.261 364.031 305.261 364.031L295.778 373.517V360.778C295.778 360.778 295.778 358 293 358C290.222 358 290.222 360.778 290.222 360.778V373.517L280.739 364.031C280.739 364.031 278.775 362.067 276.811 364.031C274.847 365.997 276.811 367.961 276.811 367.961L290.222 381.375V434.628L276.811 448.039C276.811 448.039 274.847 450.003 276.811 451.967C278.775 453.931 280.739 451.967 280.739 451.967L290.222 442.483V455.222C290.222 455.222 290.222 458 293 458C295.778 458 295.778 455.222 295.778 455.222V442.483L305.261 451.967C305.261 451.967 307.225 453.931 309.189 451.967C311.153 450.003 309.189 448.039 309.189 448.039L295.778 434.628Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M339.172 415.961C338.453 413.278 335.769 413.997 335.769 413.997L317.45 418.906L271.331 392.278L266.422 373.958C266.422 373.958 265.703 371.275 263.019 371.994C260.333 372.714 261.056 375.397 261.056 375.397L264.528 388.353L253.494 381.981C253.494 381.981 251.089 380.592 249.7 382.997C248.311 385.403 250.717 386.792 250.717 386.792L261.747 393.161L248.792 396.631C248.792 396.631 246.106 397.35 246.828 400.033C247.547 402.719 250.231 402 250.231 402L268.553 397.092L314.672 423.719L319.581 442.042C319.581 442.042 320.3 444.725 322.983 444.006C325.667 443.283 324.947 440.603 324.947 440.603L321.475 427.647L332.508 434.017C332.508 434.017 334.917 435.406 336.306 433.003C337.694 430.594 335.286 429.206 335.286 429.206L324.256 422.836L337.208 419.367C337.208 419.364 339.892 418.644 339.172 415.961Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M337.208 396.631L324.253 393.158L335.286 386.789C335.286 386.789 337.694 385.397 336.306 382.992C334.914 380.583 332.508 381.975 332.508 381.975L321.478 388.342L324.947 375.389C324.947 375.389 325.667 372.706 322.983 371.986C320.3 371.267 319.581 373.95 319.581 373.95L314.672 392.269L268.55 418.906L250.233 413.994C250.233 413.994 247.55 413.275 246.831 415.958C246.108 418.644 248.794 419.361 248.794 419.361L261.747 422.831L250.717 429.2C250.717 429.2 248.314 430.592 249.703 432.997C251.092 435.4 253.494 434.011 253.494 434.011L264.528 427.642L261.056 440.594C261.056 440.594 260.336 443.281 263.019 443.997C265.706 444.719 266.425 442.036 266.425 442.036L271.336 423.711L317.458 397.086L335.778 401.997C335.778 401.997 338.461 402.717 339.181 400.033C339.889 397.347 337.208 396.631 337.208 396.631Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_608_684"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 360,
    height: 360,
    fill: "white",
    transform: "translate(97.397 0.386261) rotate(10.5657)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_608_684"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 23,
    fill: "white",
    transform: "translate(159 331)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaviconNoel);
export default __webpack_public_path__ + "static/media/Favicon_Noel.b35722c7ff2a771c46984f0a662848b2.svg";
export { ForwardRef as ReactComponent };